<script>
import ItemCard from '@mobile/components/ItemCard.vue';
import { now } from '@/util/UnixTimestamps';

export default {
    name: 'TodosInspection',

    components: { ItemCard },

    props: {
        todo: {
            type: Object,
            required: true,
        },
    },

    computed: {
        oneAssignee() {
            return this.todo.users.length === 1;
        },

        multipleAssignees() {
            return this.todo.users.length > 1;
        },

        noDeadline() {
            return this.todo.due_at === null;
        },

        overdue() {
            return this.todo.due_at < now();
        },

    },
};
</script>


<template>
    <ItemCard :title="todo.inspection.checklist_title">
        <template v-slot:badges>
            <svg
                v-if="todo.draft"
                class="inline-block"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
            >
                <path
                fill="var(--60)"
                d="M6.3 12.3l10-10a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1 0 1.4l-10 10a1 1 0 0 1-.7.3H7a1 1 0 0 1-1-1v-4a1 1 0 0 1 .3-.7zM8 16h2.59l9-9L17 4.41l-9 9V16zm10-2a1 1 0 0 1 2 0v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h6a1 1 0 0 1 0 2H4v14h14v-6z"
                />
            </svg>

            <svg
                v-if="oneAssignee"
                class="inline-block"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
            >
                <path
                fill="var(--60)"
                d="M12 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm9 11a1 1 0 0 1-2 0v-2a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v2a1 1 0 0 1-2 0v-2a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v2z"
                />
            </svg>

            <svg
                v-else-if="multipleAssignees"
                class="inline-block"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
            >
                <path
                fill="var(--60)"
                d="M9 12A5 5 0 1 1 9 2a5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm7 11a1 1 0 0 1-2 0v-2a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2a1 1 0 0 1-2 0v-2a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v2zm1-5a1 1 0 0 1 0-2 5 5 0 0 1 5 5v2a1 1 0 0 1-2 0v-2a3 3 0 0 0-3-3zm-2-4a1 1 0 0 1 0-2 3 3 0 0 0 0-6 1 1 0 0 1 0-2 5 5 0 0 1 0 10z"
                />
            </svg>
        </template>

        <template v-if="noDeadline">
            <div class="badge state-primary">{{ $t("No deadline") }}</div>
        </template>

        <template v-else-if="overdue">
            <div class="badge state-bad">{{ $t("Overdue") }}</div>
            <p class="badge-explanation">{{ $t("since {dueAt}", { dueAt: $du(todo.due_at, 'shortDateTime') }) }}</p>
        </template>

        <template v-else>
            <div class="badge state-medium">{{ $t("Due") }}</div>
            <p class="badge-explanation">{{ $t("at {dueAt}", { dueAt: $du(todo.due_at, 'shortDateTime') }) }}</p>
        </template>

    </ItemCard>

</template>
